import PropTypes from 'prop-types';
import Checkbox from '../../../components/Checkbox/Checkbox';
import GuidelineLogo from '../../../assets/icons/Guideline.svg?react';
import ObesiDLogo from '../../../assets/icons/ObesiD.svg?react';
import DRTCLogo from '../../../assets/icons/DRTCLogo.svg?react';
import useWhitelabelAvailability from '../../../hooks/useWhitelabelAvailability';
import styles from './Institution.module.scss';

const PRODUCTS = [
  { id: 'tg', name: 'Therapeutic Guidelines', Logo: GuidelineLogo, width: 121 },
  { id: 'obesid', name: 'ObesiD', Logo: ObesiDLogo, width: 140 },
  { id: 'drtc', name: 'DRTC', Logo: DRTCLogo, width: 140 }
];

const ProductSelector = ({ selectedProducts, onProductToggle, isExisting = false }) => {
  const { isWhitelabelEnabled } = useWhitelabelAvailability();
  const visibleProducts = isExisting ? PRODUCTS.filter(product => product.id !== 'tg') : PRODUCTS;

  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Which product would you like to subscribe to?</h2>
      <div className={styles.productGrid}>
        {visibleProducts.map(product => (
          <div
            key={product.id}
            className={`${styles.productCard} ${selectedProducts.includes(product.id) ? styles.selected : ''} ${!isWhitelabelEnabled(product.id) ? styles.disabled : ''}`}
          >
            <div className={styles.productHeader}>
              <Checkbox
                checked={selectedProducts.includes(product.id)}
                onChange={() => onProductToggle(product.id)}
              />
            </div>
            <div className={styles.productLogo}>
              <product.Logo width={product.width} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

ProductSelector.propTypes = {
  selectedProducts: PropTypes.arrayOf(PropTypes.string).isRequired,
  onProductToggle: PropTypes.func.isRequired,
  isExisting: PropTypes.bool
};

export default ProductSelector;
export { PRODUCTS };
